import React from 'react';

const TextAreaFieldAdapter = ({ input, meta, ...rest }) => (
    <div style={{ display: 'flex' }}>
        <textarea 
            {...input}
            {...rest}
        />
        <span style={{ color: 'red' }}>{meta.touched ? meta.error : ''}</span>
    </div>
);

export default TextAreaFieldAdapter;


// WEBPACK FOOTER //
// ./src/js/components/Form/TextAreaFieldAdapter.jsx